import type { PropagationStatus } from "@/shared/propagation";

import { apiFetch } from "@/client/lib/api";

/**
 * Typed client for the tenant PXE menu URL endpoints. The server scopes
 * everything to the authenticated tenant (RLS), so the client never passes a
 * tenant id. `status` is `pending` until BCM's reconciler acknowledges the URL,
 * then `verified` (shown as "Active").
 */

export interface PxeMenu {
  menuUrl: string;
  status: PropagationStatus;
  requestedAt: string;
  updatedAt: string;
  verifiedAt: string | null;
  requestedByName: string | null;
}

export interface PxeMenuResponse {
  /** The tenant's configured menu, or null if none has been set. */
  pxe: PxeMenu | null;
  /** Whether NetBox is configured (the feature is usable at all). */
  netboxConfigured: boolean;
  /** Whether the write-scoped token is configured (the URL can be changed). */
  writeEnabled: boolean;
}

export const pxeApi = {
  get: () => apiFetch<PxeMenuResponse>("/pxe"),
  update: (url: string) => apiFetch<PxeMenu>("/pxe", { method: "PUT", json: { url } }),
};
